/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-front
 * Version: 7.4.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import Switcher from '@kuik/modules/switcher/switcher.js';
import {destroyAllMenuMobile, initAllMenuMobile} from '@kuik/tags/menu-mobile/menu-mobile.js';

/**
 * Gère le switch des menus.
 */
export function handleSwitch() {
    const componentMenu = document.getElementById('component-menu');

    const componentMenuDesktop= document.getElementById('component-menu-desktop');

    const componentSwitcher = new Switcher('menu-mobile', {
        element: componentMenu,
        onMounted() {
            initAllMenuMobile();
        }
    });
    // Ajoute une 2e variante (exemple de composant asynchrone)

    componentSwitcher.registerComponent('menu-desktop', {
        element: componentMenuDesktop,
        onMounted() {
            destroyAllMenuMobile();
        }
    });
    // Charger le composant mobile si la largeur de l'écran < 800px
    let lastWidth = null;
    new ResizeObserver(([ { contentRect: { width } } ]) => {
        if (width !== lastWidth) {
            lastWidth = width;
            componentSwitcher.switch(width >= 800 ? 'menu-desktop' : 'menu-mobile');
        }
    }).observe(document.body.parentElement);
    return componentSwitcher;
}

window.addEventListener('load', handleSwitch());